// External Imports
import { Fragment, useContext, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

// Internal Imports
import { isoDateToString } from "../../util/format-date";
import ListLabels from "../UI/ListLabels";
import Heading from "../UI/Heading";
import NoRecordsFound from "../UI/NoRecordsFound";
import { UtilityContext } from "../../context/util-context";

/** ========================================================================
 * * PaymentDiscounts Component
 * This component renders a list of discounts on a payment.
 * ========================================================================== */

export default function PaymentDiscounts({ discounts = [] }) {
  const { navigate } = useContext(UtilityContext);
  // Initialize States
  const [show, setShow] = useState(false);

  // Sort discounts by date
  discounts = discounts.sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  return (
    <div className="grid gap-2">
      <Heading
        title="Discounts"
        text="List of all discounts on this payment."
        onClick={() => setShow(!show)}
        isBackArrow={false}
      >
        {discounts.length > 0 && (
          <div className="px-2 text-sm text-white bg-yellow-600 rounded-full">
            {discounts.length}
          </div>
        )}
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>

      {show && (
        <Fragment>
          {discounts.length > 0 ? (
            <div className="list max-h-[400px]">
              <div className="labels lg:grid-cols-3">
                <ListLabels
                  labels={[
                    "Date Applied",
                    { name: "Code", classes: "lg:col-span-2" },
                  ]}
                />
              </div>
              {discounts.map((discount, idx) => (
                <div
                  key={idx}
                  onClick={(e) =>
                    navigate(`/coupons?query=${discount.couponId}`, e)
                  }
                  className="grid text-sm pill lg:grid-cols-3 text-stone-200"
                >
                  <p className="text-stone-400">
                    {isoDateToString(discount.dateCreated)}
                  </p>
                  <p className="text-left text-stone-400 lg:col-span-2">
                    {discount.couponId}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <NoRecordsFound />
          )}
        </Fragment>
      )}
    </div>
  );
}
